export const UPDATE_VIEWPORT_DIMENSIONS = "UPDATE_VIEWPORT_DIMENSIONS";
export type UPDATE_VIEWPORT_DIMENSIONS = typeof UPDATE_VIEWPORT_DIMENSIONS;
export const UPDATE_VIEWPORT_IS_MOBILE = "UPDATE_VIEWPORT_IS_MOBILE";
export type UPDATE_VIEWPORT_IS_MOBILE = typeof UPDATE_VIEWPORT_IS_MOBILE;
